/**
 * CZNA-1508 — what a save button says while its write is in flight.
 *
 * A button that only goes grey reads as a frozen screen: on test (27. 10. 2026) the
 * "Uložit přesto" dialog sat inert for the whole PUT and looked like a crash. Every button
 * that starts a write shows the same thing instead — the module's spinner idiom
 * (`spinner-ellipsis`, as on a running field action) and "Ukládá se…" — and the screen it
 * sits on carries one status region that says the same to a screen reader.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes/components';
/** Read by a screen reader, not shown — the button already shows it. */
var visuallyHiddenStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
};
/**
 * The button's content: its own label, or the spinner and "Ukládá se…" while `saving`.
 * The button itself takes `aria-busy={saving}`.
 */
export var SaveButtonLabel = function (_a) {
    var saving = _a.saving, labelId = _a.labelId;
    return (saving ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: '4px' }, "data-test-save-in-flight": true },
        React.createElement("span", { "aria-hidden": "true" },
            React.createElement(Icon, { icon: "spinner-ellipsis" })),
        React.createElement(FormattedMessage, { id: "ui-czna-authorities.save.inFlight" }))) : React.createElement(FormattedMessage, { id: labelId }));
};
/**
 * A polite status region, rendered always and filled only while `saving`. Always, because a
 * live region inserted together with its text is not reliably announced; the region has to
 * be in the page before what it announces changes.
 */
export var SaveInFlightAnnouncement = function (_a) {
    var saving = _a.saving;
    return (React.createElement("span", { role: "status", "aria-live": "polite", style: visuallyHiddenStyle, "data-test-save-in-flight-status": true }, saving ? React.createElement(FormattedMessage, { id: "ui-czna-authorities.save.inFlight" }) : null));
};
